import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import App from "./App.tsx";
import "./index.css";

// Native plugin initialization
if (Capacitor.isNativePlatform()) {
  import("@capacitor/status-bar").then(({ StatusBar, Style }) => {
    StatusBar.setStyle({ style: Style.Light });
    StatusBar.setOverlaysWebView({ overlay: true }).catch(() => {});
  }).catch(() => {});

  import("@capacitor/splash-screen").then(({ SplashScreen }) => {
    SplashScreen.hide();
  }).catch(() => {});
}

const rootEl = document.getElementById("root")!;
createRoot(rootEl).render(<App />);

// Keep the inline HTML splash visible until the app explicitly signals
// it is ready (VendorAuthProvider has finished its initial session
// restore). This prevents the long white-screen gap on low-RAM Android
// devices where lazy chunks and providers take several seconds to boot.
const removeSplash = () => {
  const s = document.getElementById("lov-splash");
  if (s && s.parentNode) s.parentNode.removeChild(s);
};
(window as any).__lovHideSplash = removeSplash;
// Safety net: never let the splash linger past 8 s even if something
// downstream throws before calling __lovHideSplash.
setTimeout(removeSplash, 8000);
